<template>
  <div class="search-manage">
    <!-- 头部导航组件 -->
    <header-cmp></header-cmp>
    <menu-cmp></menu-cmp>
    <section class="content page-content">
      <ul class="search-manage-tab">
        <li class="search-manage-tab-item" :class="isActive == index ? 'active': ''" v-for="(item, index) in tabMenu" :key="index" @click="handleClick(index)">
          {{item.name}}
        </li>
      </ul>
      <p class="search-manage-tips">为您找到相关结果约{{ total[isActive] }}个</p>
      <div class="search-manage-result" v-if="total[isActive]">
        <template v-if="[0, 2].includes(isActive)">
          <dashed-list :list="list[isActive]" link="/news/newsDetail?id=" :type="isActive==0 ? 'img':''" />
        </template>
        
        <template v-else-if="isActive == 4">
          <ul class="expert-list">
            <li
              v-for="(item, index) in list[isActive]"
              class="expert-list-item"
              :key="index"
            >
              <h4>{{ getName(item.name) }}</h4>
              <p>性别：{{ item.sex == 1 ? "男" :"女" }}</p>
              <p class="id-number" v-if="item.idcode">
                身份证号：<span class="number">{{getId(item.idcode) }}</span>
              </p>
              <p v-if="item.title && item.title > 1">职称：{{ getTitle(item.title) }}</p>
              <p v-if="item.refereeLevel > 1">裁判级别：{{ getRefereeLevel(item.title) }}</p>
              <p v-if = "getLocaltion(item)">常驻地：{{ getLocaltion(item) }}</p>
            </li>
          </ul>
        </template>
        <template v-else>
          <imgcard-list @itemClick="itemClick" :dataList="list[isActive]" />
        </template> 
        <div class="pagination">
          共{{ total[isActive] }}条
          <el-pagination
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
            :page-sizes="[10, 20, 30, 40]"
            :page-size="pageSize[isActive]"
            :pager-count="5"
            background
            layout="prev, pager, next"
            :total="total[isActive]"
          >
          </el-pagination>
        </div>                              
      </div>
      <div class="no-data" v-else>
        暂无数据
      </div>
    </section>
    <footer-cmp></footer-cmp>
  </div>
</template>

<script>
  import headerCmp from "../components/common/header.vue"
  import menuCmp from "../components/common/navMenu.vue"
  import footerCmp from "../components/common/footer.vue"
  import DashedList from "@/components/DashedList.vue"
  import ImgcardList from "@/components/imgcardList.vue"
  import search from '@/api/search';
  import { getExpertList } from "@/api/home/index";
  // import { delHtmlTag } from '@/utils/index.js'

  export default{ 
    data(){ 
      return{ 
        tabMenu:[{
          name:'名录',
          id:'direcories',
          link: '/news/newsDetail?id=', 
          }, {
            name:'新闻',
            id:'news',
            link: '/news/newsDetail?id='
          }, {
            name:'通告',
            id:'advise',
            link: '/news/newsDetail?id='
          }, {
            name:'证书(编号)',
            id:'certs',
            link: ''
          }, 
          // {
          //   name:'专家',
          //   id:' expert',
          //   link: ''
          // },
          // {
          //   name:'步道', 
          //   id: 'alamedas',
          //   link: '/news/newsDetail?id='
          // }
          ],
        isActive: Number(this.$route.query.tab) || 0,
        kw: this.$route.query.kw || '',
        list: [],
        pageNum: new Array(5).fill(1),
        total: [0, 0, 0, 0, 0],
        pageSize: [10, 9, 10, 9, 10],
      }
    },
    components:{ 
      headerCmp,
      menuCmp,
      footerCmp, DashedList, ImgcardList
    },
    methods:{ 
      getList(){

        const _this = this;
        const index = this.isActive;
        if(index == 4){
          //专家的查询走单独接口
          getExpertList({
            pageSize: this.pageSize[index],
            pageIndex: this.pageNum[index],
            kw: this.kw
          }).then(res=>{
            const data = res.data;                    
            _this.$set(_this.list, index,  data.list)
            _this.$set(_this.total, index,  data.total)
          })
        }else{
          search.search({
            pageSize: this.pageSize[index],
            pageIndex: this.pageNum[index],
            kw: this.kw,
            type: index
          }).then(res=>{
            console.log('getList',res.data);
            const data = res.data[this.tabMenu[index].id];                    
            _this.$set(_this.list, index,  data.list)
            _this.$set(_this.total, index,  data.total)
          })
        }
      },
      handleCurrentChange(v) {
        this.pageNum[this.isActive] = v;
        this.getList();
      },
      handleSizeChange(v){
        this.pageSize[this.isActive] = v;
        this.getList();
      },
      itemClick(item){ 
       
        if(this.isActive !=3 ){
          this.$router.push('/news/newsDetail?id=' + item.id);
        }else{
           this.$router.push(
            { name: 'certDetail' ,
              params:{item: item}
        });
        }
      },
      handleClick(index){
        this.isActive = index;
        this.getList();
      },
      getName(name) {
        return name.slice(0,name.length - 1) + "*";
      },
      getId(id){
        return id.slice(0, id.length-4) + "****";
      },
      getTitle(value){
        if(value > 0 && value < 4){
        var text = [null,"教授","副教授","高级工程师"];
        return text[value];
        }else{
          return null;
        }
      },
      getRefereeLevel(level){
        if(level == 1){
          return null;
        }
        if(level == 2){
          return "田径国家级裁判";
        }
        if(level == 3){
          return "田径国际级裁判";
        }
      },
      getLocaltion(item){
        var location = null;
        if(item.province){
          location = item.province;
          if(item.city){
            location += ' ' + item.city;
          }
        }
        return location;
      
      }
    },
    mounted(){
      this.getList();
    },
    watch: {
        $route() {
            this.kw = this.$route.query.kw;
            this.pageNum = new Array(5).fill(1);
            this.getList();
        }
    },
  }
</script>

<style lang="scss" scoped>
.search-manage{
    font-size: 14px;
    font-weight: 400; 
    --main-width: 1200px;
    line-height: 1;
    .search-manage-tab{
      font-size: 20px;
      color: #666666;
      line-height: 1.4;
      border-bottom: 1px solid #D8D8D8;
      padding-top: 40px;
      &-item{
        display: inline-block;
        margin-right: 60px;
        position: relative;
        padding-bottom: 20px;
        cursor: pointer;
      }
      &-item.active{
        font-weight: 500;
        color: #DA5351;
      }
      &-item.active::after{
        content: '';
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        height: 2px;
        background: #DA5351;
      }
    }
    .search-manage-tips{
      margin: 16px 0 24px;
      color: #666666;
      line-height: 20px;
    }
    .no-data{
      text-align: center;
    }
    .expert-list{
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
          width: 100%;
          &-item {
            width: 49%;
            border-radius: 8px;
            border: 1px solid #f1f1f1;
            margin-top: 15px;
            padding: 16px 26px 16px 26px;
            line-height: 25px;
            box-sizing: border-box;
            color: #99999a;
            font-size: 16px;
            span.number {
              color: #da5351;
            }
            h4 {
              font-size: 20px;
              line-height: 35px;
              color: #333;
              width: 100%;
            }
            .id-number {
            }
          }
    }
}
@media screen and (max-width:960px){
  .search-manage{
    .content{
      .search-manage-tab{
          width: 100%;
          display: flex;
          justify-content: space-between;
          border-bottom-color: #f1f1f1;
          padding-top: .16rem;
          &-item{
            margin-right: 0;
            font-size: .16rem;
            line-height: .24rem;
            padding-bottom: .12rem;
          }
          &-item.active{
            font-size: .18rem;
          }
      }
      .search-manage-tips{
        margin: .12rem 0 .16rem;
        font-size: .12rem;
      }
    }
    .expert-list{
      &-item {
        width: 100%;
        margin: 0;
        padding: 0;
        font-size: 0.12rem;
        line-height: 0.18rem;
        border: 0;
        border-bottom: 1px solid #f1f1f1;
        border-radius: 0;
        padding: 0.12rem 0;
        h4 {
          font-size: 0.14rem;
          font-weight: 500;
          color: #454545;
          line-height: 0.2rem;
        }
      }
    }
  }
}
</style>